export const footerLinkList = (lists: NodeListOf<HTMLElement>): void => {
  lists.forEach((list: HTMLElement) => {
    const items: NodeListOf<HTMLElement> = list.querySelectorAll('[data-footer-link-list-item]');

    items.forEach((item: HTMLElement) => {
      item.addEventListener('click', (event: Event) => {
        const target = event.target as HTMLElement;

        if (target.closest('a')) {
          return;
        }

        const listItem = target.closest('.footer-link-list__item');

        if (listItem) {
          listItem.classList.toggle('footer-link-list__item--collapsed');

          const icon = listItem.querySelector('[data-footer-link-list-title-icon]');
          if (icon) {
            icon.classList.toggle('footer-link-list__title-icon--rotate');
          }
        }
      });
    });
  });
};
